import React, { ReactNode, useState } from 'react';
import { createTRPCReact } from '@trpc/react-query';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { httpBatchLink } from '@trpc/client';

import { AppRouter } from '../../../core/src/server/trpc';
export const trpc = createTRPCReact<AppRouter>();

export const TrpcProvider = ({ children }: { children: ReactNode }) => {
  const [queryClient] = useState(() => {
    const client = new QueryClient();

    return client;
  });
  const [trpcClient] = useState(() => {
    const links = [
      httpBatchLink({
        url: '/core/trpc',
        headers: () => ({
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        }),
      }),
    ];

    return trpc.createClient({
      links,
    });
  });

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        {children}

        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </trpc.Provider>
  );
};

export type { RouterInput, RouterOutput } from '../../../core/src/server/trpc';
